import LayoutController from './layout-controller'

export default LayoutController
